import styled from 'styled-components';

import DotExplanation from '@/components/ContextPrinter/DotExplanation';
import StringUtil from '@/utils/StringUtil';
import { FontStyle } from '@/utils/StyleUtil';
import {CONFIRMATION_EFFECTIVEDATE_GUIDE_TEXT, CONFIRMATION_EFFECTIVEDATE_PART_TEXT} from "@/models";
import React from "react";

interface Props {
    associationNumber: string;
    advConfirmationCode: string;
    advConfirmationEffectiveDateStartedAt: Date;
    advConfirmationEffectiveDateExpiredAt: Date;
}

export default function ConfirmationEffectiveDatePart({
    associationNumber,
    advConfirmationCode,
    advConfirmationEffectiveDateStartedAt,
    advConfirmationEffectiveDateExpiredAt,
}: Props) {
    return (
        <Container>
            <DotExplanation
                contents={CONFIRMATION_EFFECTIVEDATE_PART_TEXT.map(v => ({ parent: v }))}
                parentStyle={FontStyle(12, 20, '400', '#acacac')}
                containerStyle={{ padding: 0 }}
            />
            {associationNumber && (
                <DotExplanation
                    contents={[{ parent: `협회등록번호 ${associationNumber}` }]}
                    parentStyle={FontStyle(12, 20, '400', '#acacac')}
                    containerStyle={{ padding: 0 }}
                />
            )}
            {advConfirmationEffectiveDateStartedAt && advConfirmationEffectiveDateExpiredAt && (
                <DotExplanation
                    contents={[
                        {
                            parent: `${advConfirmationCode}\n(${StringUtil.displayedDateAt(
                                advConfirmationEffectiveDateStartedAt,
                            )}~${StringUtil.displayedDateAt(advConfirmationEffectiveDateExpiredAt)})`,
                        },
                    ]}
                    parentStyle={FontStyle(12, 20, '400', '#acacac')}
                    containerStyle={{ padding: 0 }}
                />
            )}
            <DotExplanation
                contents={CONFIRMATION_EFFECTIVEDATE_GUIDE_TEXT.map(v => ({ parent: v }))}
                containerStyle={{ padding: 0 }}
                parentStyle={FontStyle(12, 20, '400', '#ACACAC')}
            />
        </Container>
    );
}

const Container = styled.div``;
